import React from 'react'
import ModalWrapper from '../ModalWrapper'
import AddBackupEmailContainer from '../../../containers/modals/account/AddBackupEmailContainer'

const AddBackupEmailModal = (props) => {
  const { hideModal } = props
  return (
    <div className='emailVerificationFlow-modalContainer marketing'>
      <ModalWrapper hideModal={hideModal} showModalHeader={false} modalStyle='dark'>
        <div className='emailVerificationFlow-modalContent'>
          <AddBackupEmailContainer hideModal={hideModal} />
        </div>
      </ModalWrapper>
    </div>
  )
}

export default AddBackupEmailModal
